<template>
  <section id="hero" class="d-flex flex-column justify-content-center align-items-center">
    <div class="hero-container" data-aos="fade-in">
      <h1>Matteo O. Bovero</h1>
      <p><i>Software Engineer, Developer, Photographer, Scuba Diver</i></p>
    </div>
  </section>
</template>